/**
 * InfoTip(#13)의 순수 상호작용 로직.
 * 데스크탑 hover / 모바일 탭 토글 / esc·바깥클릭 닫힘을 한 reducer로 모은다.
 * 컴포넌트는 이 함수만 호출하고 DOM 이벤트 배선만 담당한다(테스트 가능).
 */

export type TooltipEvent =
  | { type: 'pointerEnter' } // 데스크탑 마우스 진입 → 열기
  | { type: 'pointerLeave' } // 데스크탑 마우스 이탈 → 닫기
  | { type: 'tap' } // 모바일 탭 / 키보드 activate → 토글
  | { type: 'escape' } // esc → 닫기
  | { type: 'outside' }; // 바깥 클릭 → 닫기

export const nextTooltipOpen = (
  open: boolean,
  event: TooltipEvent,
): boolean => {
  switch (event.type) {
    case 'pointerEnter':
      return true;
    case 'pointerLeave':
    case 'escape':
    case 'outside':
      return false;
    case 'tap':
      return !open;
    default:
      return open;
  }
};

/**
 * 클릭이 "탭"으로 취급돼야 하는지 판단한다.
 * 마우스 클릭은 hover가 이미 처리하므로 무시하고, 터치/펜/키보드(pointerType 미상)만 토글한다.
 */
export const isTapPointer = (pointerType: string): boolean =>
  pointerType !== 'mouse';
